'use client';

import { forwardRef } from 'react';

import { cn } from '@/lib/cn';
import { GuideOrb } from './GuideOrb';

interface GuideOrbButtonProps {
  onClick: () => void;
  ariaLabel: string;
  active?: boolean;
  className?: string;
  controls?: string;
  hasPopup?: 'menu' | 'dialog';
}

export const GuideOrbButton = forwardRef<HTMLButtonElement, GuideOrbButtonProps>(function GuideOrbButton({
  onClick,
  ariaLabel,
  active = false,
  className,
  controls,
  hasPopup,
}, ref) {
  return (
    <button
      ref={ref}
      type="button"
      onClick={onClick}
      className={cn(
        'relative inline-flex h-16 w-16 items-center justify-center rounded-full transition-transform motion-safe:hover:scale-105 motion-safe:active:scale-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#4ABDE9] focus-visible:ring-offset-4',
        className,
      )}
      aria-label={ariaLabel}
      aria-expanded={active}
      aria-haspopup={hasPopup}
      aria-controls={controls}
    >
      <GuideOrb />
    </button>
  );
});
